import Modal from "./Modal"

export default function SendPasswordResetModal({ userName, onConfirm, onCancel }) {

    return(
        <Modal>
            <h3 className='text-lg font-bold text-gray-800 mb-4'>
                send password reset?
            </h3>
            <p>
                this will send a password reset email to <strong>{userName}</strong>
            </p>

            <div className='flex justify-end gap-3'>
                <button onClick={onCancel} className='w-full rounded-lg border border-slate/30 bg-white px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200/5'>
                    cancel
                </button>
                <button onClick={onConfirm} className='w-full rounded-lg border border-docpgrPurple/30 bg-white px-4 py-2 text-sm font-semibold text-docpgrPurple hover:bg-docpgrPurple/5 hover:shadow-docpgr-purple-glow transition'> 
                    send reset email
                </button>
            </div>
        </Modal>
    )
}